import Swiper from "swiper";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export const initEminogluTestimonials = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".eminoglu-testimonials__swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((sliderElement) => {
    const slideCount = sliderElement.querySelectorAll(".swiper-slide").length;

    new Swiper(sliderElement, {
      modules: [Pagination, Autoplay, EffectFade],
      // We use fade effect because sliding a card with an overlapping image
      // out of the container can cause visual clipping issues in some browsers.
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: slideCount > 1, // Only loop if more than 1 testimonial exists
      grabCursor: true,
      autoHeight: false,

      autoplay:
        slideCount > 1
          ? {
              delay: 6000, // Read time for text
              disableOnInteraction: true,
            }
          : false,

      pagination: {
        el: sliderElement.querySelector(
          ".eminoglu-testimonials__pagination",
        ) as HTMLElement,
        clickable: true,
      },
    });
  });

  console.log("[EminogluTestimonials] Slider initialized.");
};
